export const fileDownloadListVariationTypesAvailable = {
  Any: "Any",
  Format2: "Format2"
};

const FileDownloadList = {
  LabelFileName: "File name",
  LabelView: "View and download",
  LabelDownload: "Download"
};

export const FileDownloadHeaders = {
  Any: FileDownloadList
};

export default FileDownloadList;
